import React, { useState } from "react";
import CustomFormInput from "../forms/CustomFormInput";

/**
 * ConflictModal component for handling ICS import conflicts
 * Extracted from AdminConsole.js (lines 453-537) for reusability
 * Maintains exact same functionality and styling
 *
 * MIGRATION NOTE (2026-02-06): Migrated to CustomFormInput component
 * Part of DL-04FEB26-01: CustomFormInput migration
 */
const ConflictModal = ({ conflicts, onResolve }) => {
    const [resolutions, setResolutions] = useState(
        conflicts.map(conflict => ({
            ...conflict,
            action: "skip", // 'skip', 'overwrite', 'update'
        }))
    );

    const updateResolution = (index, action) => {
        const newResolutions = [...resolutions];
        newResolutions[index].action = action;
        setResolutions(newResolutions);
    };

    const getConflictMessage = conflict => {
        switch (conflict.conflictType) {
            case "past_event":
                // Backend returns plain ISO strings now (not $date wrapper)
                const dateStr = conflict.newEvent.eventStartDateTime;
                return `This event is in the past (${new Date(dateStr).toLocaleDateString()}). Please check your file.`;
            case "facebook_duplicate":
                return `This Facebook event already exists (imported via ${conflict.existingSource})`;
            case "ical_update":
                return `This event may have been updated since last import`;
            case "potential_duplicate":
                return `Potential duplicate found based on title and date`;
            default:
                return `Conflict detected`;
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Event Conflicts Detected</h3>
                {resolutions.map((resolution, index) => (
                    <div key={index} className="conflict-item">
                        <h4>{resolution.newEvent.title}</h4>
                        <p className="conflict-message">{getConflictMessage(resolution)}</p>
                        <p className="conflict-details">
                            Existing: {resolution.existingSource} (Last updated:{" "}
                            {new Date(resolution.lastUpdated).toLocaleDateString()})
                            {/* <br />
                            New: iCalendar import */}
                        </p>

                        <div className="conflict-actions">
                            <CustomFormInput
                                type="radio"
                                variant="turquoise"
                                layout="standard"
                                name={`conflict-${index}`}
                                value="skip"
                                label="Skip (keep existing)"
                                checked={resolution.action === "skip"}
                                onChange={() => updateResolution(index, "skip")}
                            />
                            <CustomFormInput
                                type="radio"
                                variant="orange"
                                layout="standard"
                                name={`conflict-${index}`}
                                value="overwrite"
                                label="Overwrite with iCal data"
                                checked={resolution.action === "overwrite"}
                                onChange={() => updateResolution(index, "overwrite")}
                            />
                            {resolution.conflictType === "ical_update" && (
                                <CustomFormInput
                                    type="radio"
                                    variant="purple"
                                    layout="standard"
                                    name={`conflict-${index}`}
                                    value="update"
                                    label="Update existing event"
                                    checked={resolution.action === "update"}
                                    onChange={() => updateResolution(index, "update")}
                                />
                            )}
                        </div>
                    </div>
                ))}

                <div className="modal-actions">
                    <button onClick={() => onResolve(resolutions)}>Apply Decisions</button>
                    <button onClick={() => onResolve([])}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ConflictModal;